var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDrip = function SvgDrip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "23px",
    viewBox: "0 0 14 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Drip")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Drip",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,21.9999997 C10.3137083,21.9999997 13,19.3137082 13,15.9999999 C13,14.3504701 12.3343522,12.856412 11.2570176,11.7717849 C10.5324159,11.0422776 9.11341,7.77231854 7,1.96190774 C5.0068884,7.71997638 3.6542736,10.9260861 2.9421556,11.580237 C1.74828184,12.6769268 1,14.2510772 1,15.9999999 C1,19.3137082 3.68629156,21.9999997 7,21.9999997 Z",
    id: "Oval",
    stroke: "#0F65A2",
    fill: "#0E75BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5,16.5 C3.5,18.5 4.5,19.5 6.5,19.5",
    id: "Line",
    stroke: "#FFFFFF",
    strokeLinecap: "square"
  }))));
};

export { SvgDrip as ReactComponent };
export default __webpack_public_path__ + "static/media/Drip.59988f48.svg";